module.exports = __webpack_public_path__ + "img/profile_credential_014.3a151160.png";